import React from 'react';

function TabInfo({ text, index, activeTabIndex, handleClick }) {
  return (
    <div
      className={`keno-tab-item ${index === activeTabIndex ? 'active' : ''}`}
      onClick={() => handleClick(index)}
    >
      <div className='keno-tab-item-content'>
        <span className='keno-tab-item-txt'>{text}</span>
      </div>
    </div>
  );
}
export default TabInfo;
